
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { environment } from './../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log("Jwt interceptor start");
        //-- add auth header with jwt if user is logged in and request is to api url
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                params: request.params
                    .set("profileId", localStorage.currentProfileId)
                    .set("roleId", localStorage.currentUserRoleId),
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
            // request = request.clone({
            //     params: request.params.set("serviceId", localStorage.currentUserService)
            //         .set("currentUserRole", localStorage.currentUserRole)
            //         .set("currentUserRoleId", localStorage.currentUserRoleId),
            //     setHeaders: {
            //         Authorization: `Bearer ${currentUser.token}`
            //     }
            // });
        }

        return next.handle(request);
    }
}